import { makeAutoObservable } from 'mobx';
import { SymbolTypeEnum, UnrealizedAllocationDto } from '../../../../defs/api';

export class UnrealizedAllocationMobxDto implements UnrealizedAllocationDto {
    symbol: string;

    symbolName: string;

    dateTo: Date;

    symbolCurrency: string = '';

    exchangeId: string = '';

    symbolId: string = '';

    referenceSymbolId?: string;

    referenceSymbolCurrency?: string;

    type: SymbolTypeEnum = SymbolTypeEnum.Cs;

    invested: number;

    realizedInvestmentValue: number;

    averageInvested: number;

    value: number;

    averageValue: number;

    currentUnitPrice: number;

    currency: string;

    amount: number;

    weight: number;

    color: string;

    profitPercentage: number;

    profitValue: number;

    liveProfitValue: number;

    liveProfitPercentage: number;

    currencyImpactValue: number;

    currencyImpactPercentage: number;

    totalProfitPercentage: number;

    totalProfitValue: number;

    dividendsValue: number;

    feesValue: number;

    taxFreeAmount: number;

    taxFreeValue: number;

    constructor() {
        makeAutoObservable(this);
    }

    static create(dto: UnrealizedAllocationDto): UnrealizedAllocationMobxDto {
        const mobxDto = new UnrealizedAllocationMobxDto();
        Object.assign(mobxDto, dto);

        mobxDto.liveProfitValue = mobxDto.profitValue ?? 0;
        mobxDto.liveProfitPercentage = mobxDto.profitPercentage ?? 0;

        return mobxDto;
    }

    static createFromArray(dtos: UnrealizedAllocationDto[]): UnrealizedAllocationMobxDto[] {
        return dtos.map((dto) => UnrealizedAllocationMobxDto.create(dto));
    }

    setLiveProfit(liveProfitValue: number, liveProfitPercentage: number) {
        this.liveProfitValue = liveProfitValue;
        this.liveProfitPercentage = liveProfitPercentage;
    }
}
